import NullState from '../enums/NullState';
import NullStateLocation from '../enums/NullStateLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logNullStateViewedParams = {
  null_location: NullStateLocation;
  null_state: NullState;
  trail_id?: number;
};

/**
 * User views a null state. These are typically full screen events with the exception of location missing toasts on the explore screens.
 * @param params - Attributes to log with the amplitude event
 * @param params.null_location - The location in the app where the user received the null state
 * @param params.null_state - The null state shown to the user
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logNullStateViewed = ({ null_location, null_state, trail_id }: logNullStateViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('null state viewed', { 'null location': null_location, 'null state': null_state, 'trail id': trail_id }, callback);
};

export default logNullStateViewed;
